import { styledComponent, lineHeightStyle } from '../../../../utils/helpers';
import ChiefComplainDeleteBtn from '../chiefComplainDeleteBtn';

const NervousSystem = ({
  selectedOnExamination,
  setSelectedOnExamination,
  prescriptionItems,
  isDelBtn = true,
}) => {
  let { nervousSystem } = selectedOnExamination || {};

  const deleteData = (itemName) => {
    if (!nervousSystem) return;

    switch (itemName) {
      case 'consciousness.status':
        nervousSystem.consciousness.status = '';
        break;
      case 'gcs.value':
        nervousSystem.gcs.value = '';
        break;
      case 'gcs.note':
        nervousSystem.gcs.note = '';
        break;
      case 'consciousness.note':
        nervousSystem.consciousness.note = '';
        break;
      case 'delusion.status':
        nervousSystem.delusion.status = '';
        break;
      case 'delusion.note':
        nervousSystem.delusion.note = '';
        break;
      case 'orientation':
        nervousSystem.orientation.status = '';
        nervousSystem.orientation.type = '';
        break;
      case 'orientation.note':
        nervousSystem.orientation.note = '';
        break;
      case 'hallucination':
        nervousSystem.hallucination.status = '';
        nervousSystem.hallucination.type = '';
        break;
      case 'hallucination.note':
        nervousSystem.hallucination.note = '';
        break;
      case 'memory':
        nervousSystem.memory.status = '';
        nervousSystem.memory.type = '';
        break;
      case 'memory.note':
        nervousSystem.memory.note = '';
        break;
      case 'mmse.value':
        nervousSystem.mmse.value = '';
        break;
      case 'mmse.note':
        nervousSystem.mmse.note = '';
        break;

      case 'speech':
        nervousSystem.speech.status = '';
        nervousSystem.speech.type = '';
        break;
      case 'speech.note':
        nervousSystem.speech.note = '';
        break;

      case 'cranialNerves':
        nervousSystem.cranialNerves.status = '';
        nervousSystem.cranialNerves.type = '';
        break;
      case 'cranialNerves.note':
        nervousSystem.cranialNerves.note = '';
        break;
      case 'wasting':
        nervousSystem.wasting.status = '';
        nervousSystem.wasting.type = '';
        break;
      case 'wasting.note':
        nervousSystem.wasting.note = '';
        break;

      case 'power':
        nervousSystem.power.value = '';
        nervousSystem.power.type = '';
        break;
      case 'power.note':
        nervousSystem.power.note = '';
        break;

      case 'jerks.biceps':
      case 'jerks.triceps':
      case 'jerks.supinator':
      case 'jerks.knee':
      case 'jerks.ankle':
      case 'jerks.jaw': {
        const jerkKey = itemName.split('.')[1];
        if (nervousSystem.jerks && nervousSystem.jerks[jerkKey]) {
          nervousSystem.jerks[jerkKey] = {
            checked: false,
            status: '',
            note: '',
          };
        }
        break;
      }

      case 'plantorResponse.glabellar':
      case 'plantorResponse.planterRt':
      case 'plantorResponse.planterLt': {
        const reflexKey = itemName.split('.')[1];
        if (
          nervousSystem.plantorResponse &&
          nervousSystem.plantorResponse[reflexKey]
        ) {
          nervousSystem.plantorResponse[reflexKey] = {
            checked: false,
            status: '',
            note: '',
          };
        }
        break;
      }

      case 'cerebellarFunction':
        nervousSystem.cerebellarFunction.status = '';
        nervousSystem.cerebellarFunction.type = '';
        break;
      case 'cerebellarFunction.note':
        nervousSystem.cerebellarFunction.note = '';
        break;

      case 'sensorySystem':
        nervousSystem.sensorySystem.status = '';
        nervousSystem.sensorySystem.type = '';
        break;
      case 'sensorySystem.note':
        nervousSystem.sensorySystem.note = '';
        break;

      case 'slrTest.rt':
        nervousSystem.slrTest.rt = '';
        break;
      case 'slrTest.lt':
        nervousSystem.slrTest.lt = '';
        break;

      case 'gaitFunction':
        nervousSystem.gaitFunction.status = '';
        nervousSystem.gaitFunction.type = '';
        break;
      case 'gaitFunction.note':
        nervousSystem.gaitFunction.note = '';
        break;

      case 'neckRigidity.status':
        nervousSystem.neckRigidity.status = '';
        break;
      case 'neckRigidity.note':
        nervousSystem.neckRigidity.note = '';
        break;

      case 'kernigSign.status':
        nervousSystem.kernigSign.status = '';
        break;
      case 'kernigSign.note':
        nervousSystem.kernigSign.note = '';
        break;

      case 'brudzinskiSign.status':
        nervousSystem.brudzinskiSign.status = '';
        break;
      case 'brudzinskiSign.note':
        nervousSystem.brudzinskiSign.note = '';
        break;

      case 'jvp.status':
        nervousSystem.jvp.status = '';
        break;
      case 'jvp.note':
        nervousSystem.jvp.note = '';
        break;
      case 'pulse.status':
        nervousSystem.pulse.status = '';
        break;
      case 'pulse.note':
        nervousSystem.pulse.note = '';
        break;
      case 'murmur.status':
        nervousSystem.murmur.status = '';
        break;
      case 'murmur.note':
        nervousSystem.murmur.note = '';
        break;

      case 'ascitis.status':
        nervousSystem.ascitis.status = '';
        break;
      case 'ascitis.note':
        nervousSystem.ascitis.note = '';
        break;
      case 'hepatomegaly.status':
        nervousSystem.hepatomegaly.status = '';
        break;
      case 'hepatomegaly.note':
        nervousSystem.hepatomegaly.note = '';
        break;
      case 'splenomegaly.status':
        nervousSystem.splenomegaly.status = '';
        break;
      case 'splenomegaly.note':
        nervousSystem.splenomegaly.note = '';
        break;

      case 'rr.status':
        nervousSystem.rr.status = '';
        break;
      case 'rr.note':
        nervousSystem.rr.note = '';
        break;
      case 'rhanchi.status':
        nervousSystem.rhanchi.status = '';
        break;
      case 'rhanchi.note':
        nervousSystem.rhanchi.note = '';
        break;
      case 'creps.status':
        nervousSystem.creps.status = '';
        break;
      case 'creps.note':
        nervousSystem.creps.note = '';
        break;
      case 'breathSound.status':
        nervousSystem.breathSound.status = '';
        break;
      case 'breathSound.note':
        nervousSystem.breathSound.note = '';
        break;
      default:
    }
    setSelectedOnExamination({
      ...selectedOnExamination,
      nervousSystem: { ...nervousSystem },
    });
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['on-examination']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['on-examination']?.subItemStyle || {},
  );

  const flexRow = { display: 'flex', justifyContent: 'space-between', alignItems: 'center' };

  return (
    <div className="breast-exam-view" style={lineHeightStyle('on-examination', prescriptionItems)}>
      {(nervousSystem?.gcs?.value ||
        nervousSystem?.gcs?.note ||
        nervousSystem?.consciousness?.status ||
        nervousSystem?.consciousness?.note ||
        nervousSystem?.orientation?.status ||
        nervousSystem?.orientation?.type ||
        nervousSystem?.orientation?.note ||
        nervousSystem?.delusion?.status ||
        nervousSystem?.delusion?.note ||
        nervousSystem?.hallucination?.status ||
        nervousSystem?.hallucination?.type ||
        nervousSystem?.hallucination?.note ||
        nervousSystem?.memory?.status ||
        nervousSystem?.memory?.type ||
        nervousSystem?.memory?.note ||
        nervousSystem?.mmse?.value ||
        nervousSystem.jerks.type ||
        nervousSystem?.mmse?.note ||
        nervousSystem?.speech?.status ||
        nervousSystem?.speech?.note ||
        nervousSystem?.senseOfTimePlacePosition?.status) && (
        <div className="pl-2 fw-bold">
          <b>Higher Cerebral Function</b>
        </div>
      )}
      <ul>
        {/* Render GCS */}
        {nervousSystem?.gcs?.value && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>GCS: </Title>
              <Value>{nervousSystem.gcs.value}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('gcs.value')}
              itemName="gcs.value"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render GCS with Note */}
        {nervousSystem?.gcs?.value && nervousSystem?.gcs?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.gcs.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('gcs.note')}
              itemName="gcs.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.gcs?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>GCS: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.gcs.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('gcs.note')}
                itemName="gcs.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Consciousness Level */}
        {nervousSystem?.consciousness?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Level of Consciousness: </Title>
              <Value>{nervousSystem.consciousness.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('consciousness.status')}
              itemName="consciousness.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Consciousness Level with Note */}
        {nervousSystem?.consciousness?.status &&
        nervousSystem?.consciousness?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.consciousness.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('consciousness.note')}
              itemName="consciousness.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.consciousness?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Level of Consciousness: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.consciousness.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('consciousness.note')}
                itemName="consciousness.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Orientation */}
        {(nervousSystem?.orientation?.status ||
          nervousSystem?.orientation?.note) && (
          <li>
            <div style={flexRow}>
              <span className="text-left">
                <Title>Orientation: </Title>
                <Value>
                  {nervousSystem.orientation.status}
                  {/* Only render the type if status is 'lost' */}
                  {nervousSystem.orientation.status === 'lost' &&
                  nervousSystem.orientation.type
                    ? ` - ${nervousSystem.orientation.type}`
                    : ''}
                </Value>
              </span>

              {/* Delete button for status and type */}
              {(nervousSystem.orientation.status ||
                nervousSystem.orientation.type) && (
                <ChiefComplainDeleteBtn
                  action={() => deleteData('orientation')}
                  itemName="orientation"
                  isDelBtn={isDelBtn}
                />
              )}
            </div>

            {/* Render Note on a new line */}
            {nervousSystem.orientation.note && (
              <div style={flexRow}>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.orientation.note}</Value>
                </span>

                {/* Delete button for note (only one delete button when note exists) */}
                <ChiefComplainDeleteBtn
                  action={() => deleteData('orientation.note')}
                  itemName="orientation.note"
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
          </li>
        )}

        {/* Render Delusion Level */}
        {nervousSystem?.delusion?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Delusion: </Title>
              <Value>{nervousSystem.delusion.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('delusion.status')}
              itemName="delusion.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Delusion Level with Note */}
        {nervousSystem?.delusion?.status && nervousSystem?.delusion?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.delusion.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('delusion.note')}
              itemName="delusion.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.delusion?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Delusion: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.delusion.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('delusion.note')}
                itemName="delusion.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Hallucination */}
        {(nervousSystem?.hallucination?.status ||
          nervousSystem?.hallucination?.note) && (
          <li>
            <div style={flexRow}>
              <span className="text-left">
                <Title>Hallucination: </Title>
                <Value>
                  {nervousSystem.hallucination.status}
                  {/* Only render the type if status is 'present' */}
                  {nervousSystem.hallucination.status === 'present' &&
                  nervousSystem.hallucination.type
                    ? ` - ${nervousSystem.hallucination.type}`
                    : ''}
                </Value>
              </span>

              {/* Delete button for status and type */}
              {(nervousSystem.hallucination.status ||
                nervousSystem.hallucination.type) && (
                <ChiefComplainDeleteBtn
                  action={() => deleteData('hallucination')}
                  itemName="hallucination"
                  isDelBtn={isDelBtn}
                />
              )}
            </div>

            {/* Render Note on a new line */}
            {nervousSystem.hallucination.note && (
              <div style={flexRow}>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.hallucination.note}</Value>
                </span>

                {/* Delete button for note (only one delete button when note exists) */}
                <ChiefComplainDeleteBtn
                  action={() => deleteData('hallucination.note')}
                  itemName="hallucination.note"
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
          </li>
        )}

        {/* Render Memory */}
        {(nervousSystem?.memory?.status || nervousSystem?.memory?.note) && (
          <li>
            <div style={flexRow}>
              <span className="text-left">
                <Title>Memory: </Title>
                <Value>
                  {nervousSystem.memory.status}
                  {/* Only render the type if status is 'lost' */}
                  {nervousSystem.memory.status === 'lost' &&
                  nervousSystem.memory.type
                    ? ` - ${nervousSystem.memory.type}`
                    : ''}
                </Value>
              </span>

              {/* Delete button for status and type */}
              {(nervousSystem.memory.status || nervousSystem.memory.type) && (
                <ChiefComplainDeleteBtn
                  action={() => deleteData('memory')}
                  itemName="memory"
                  isDelBtn={isDelBtn}
                />
              )}
            </div>

            {/* Render Note on a new line */}
            {nervousSystem.memory.note && (
              <div style={flexRow}>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.memory.note}</Value>
                </span>

                {/* Delete button for note (only one delete button when note exists) */}
                <ChiefComplainDeleteBtn
                  action={() => deleteData('memory.note')}
                  itemName="memory.note"
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
          </li>
        )}

        {/* Render MMSE */}
        {nervousSystem?.mmse?.value && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>MMSE: </Title>
              <Value>{nervousSystem.mmse.value}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('mmse.value')}
              itemName="mmse.value"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render MMSE with Note */}
        {nervousSystem?.mmse?.value && nervousSystem?.mmse?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.mmse.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('mmse.note')}
              itemName="mmse.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.mmse?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>MMSE: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.mmse.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('mmse.note')}
                itemName="mmse.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}
        {(nervousSystem?.speech?.status || nervousSystem?.speech?.note) && (
          <li>
            <div style={flexRow}>
              <span className="text-left">
                <Title>Speech: </Title>
                <Value>
                  {nervousSystem.speech.status}
                  {/* Render type only if status exists */}
                  {nervousSystem.speech.status && nervousSystem.speech.type
                    ? ` - ${nervousSystem.speech.type}`
                    : ''}
                </Value>
              </span>

              {/* Delete button for status and type */}
              {nervousSystem.speech.status && (
                <ChiefComplainDeleteBtn
                  action={() => deleteData('speech')}
                  itemName="speech"
                  isDelBtn={isDelBtn}
                />
              )}
            </div>

            {/* Render Note on a new line */}
            {nervousSystem.speech.note && (
              <div style={flexRow}>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.speech.note}</Value>
                </span>

                {/* Delete button for note */}
                <ChiefComplainDeleteBtn
                  action={() => deleteData('speech.note')}
                  itemName="speech note"
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
          </li>
        )}
        {nervousSystem?.senseOfTimePlacePosition?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Sense of Time, place and position: </Title>
              <Value>{nervousSystem?.senseOfTimePlacePosition?.status}</Value>
            </span>

            {/* Delete button for status and type */}
            {nervousSystem.speech.status && (
              <ChiefComplainDeleteBtn
                action={() => deleteData('senseOfTime')}
                itemName="senseOfTime"
                isDelBtn={isDelBtn}
              />
            )}
          </li>
        )}
      </ul>

      {(nervousSystem?.cranialNerves?.status ||
        nervousSystem?.cranialNerves?.note) && (
        <div className="pl-2 fw-bold">
          <b>Cranial Nerves</b>
        </div>
      )}
      <ul>
        {/* Render Cranial Nerves */}
        {(nervousSystem?.cranialNerves?.status ||
          nervousSystem?.cranialNerves?.note) && (
          <li>
            <div style={flexRow}>
              <span className="text-left">
                <Title>Cranial Nerves: </Title>
                <Value>
                  {nervousSystem.cranialNerves.status}
                  {/* Only render the type if status is 'palsy' */}
                  {nervousSystem.cranialNerves.status === 'palsy' &&
                  nervousSystem.cranialNerves.type
                    ? ` - ${nervousSystem.cranialNerves.type}`
                    : ''}
                </Value>
              </span>

              {/* Delete button for status and type */}
              {(nervousSystem.cranialNerves.status ||
                nervousSystem.cranialNerves.type) && (
                <ChiefComplainDeleteBtn
                  action={() => deleteData('cranialNerves')}
                  itemName="cranial nerves"
                  isDelBtn={isDelBtn}
                />
              )}
            </div>

            {/* Render Note on a new line */}
            {nervousSystem.cranialNerves.note && (
              <div style={flexRow}>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.cranialNerves.note}</Value>
                </span>

                {/* Delete button for note (only one delete button when note exists) */}
                <ChiefComplainDeleteBtn
                  action={() => deleteData('cranialNerves.note')}
                  itemName="cranial nerves note"
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
          </li>
        )}
      </ul>
      {(nervousSystem?.wasting?.status ||
        nervousSystem?.wasting?.type ||
        nervousSystem?.wasting?.note ||
        nervousSystem?.power.value ||
        nervousSystem?.power.type ||
        nervousSystem?.power.note ||
        Object.values(nervousSystem?.jerks || {}).some(
          (item) => item?.checked,
        ) ||
        Object.values(nervousSystem?.plantorResponse || {}).some(
          (item) => item?.checked,
        ) ||
        nervousSystem?.cerebellarFunction?.status ||
        nervousSystem?.cerebellarFunction?.type ||
        nervousSystem?.cerebellarFunction?.note ||
        nervousSystem?.sensorySystem?.status ||
        nervousSystem?.sensorySystem?.note ||
        nervousSystem?.sensorySystem?.type ||
        nervousSystem?.slrTest?.rt ||
        nervousSystem?.slrTest?.lt ||
        nervousSystem?.gaitFunction?.status ||
        nervousSystem?.gaitFunction?.type ||
        nervousSystem?.gaitFunction?.note ||
        nervousSystem?.gaitFunction?.status ||
        nervousSystem?.gaitFunction?.type ||
        nervousSystem?.gaitFunction?.note) && (
        <div className="pl-2 fw-bold">
          <b>Motor Function</b>
        </div>
      )}
      <ul>
        {/* Render Wasting */}
        {(nervousSystem?.wasting?.status || nervousSystem?.wasting?.note) && (
          <li>
            <div style={flexRow}>
              <span className="text-left">
                <Title>Wasting: </Title>
                <Value>
                  {nervousSystem.wasting.status}
                  {/* Only render the type if status is 'present' */}
                  {nervousSystem.wasting.status === 'present' &&
                  nervousSystem.wasting.type
                    ? ` - ${nervousSystem.wasting.type}`
                    : ''}
                </Value>
              </span>

              {/* Delete button for status and type */}
              {(nervousSystem.wasting.status || nervousSystem.wasting.type) && (
                <ChiefComplainDeleteBtn
                  action={() => deleteData('wasting')}
                  itemName="wasting"
                  isDelBtn={isDelBtn}
                />
              )}
            </div>

            {/* Render Note on a new line */}
            {nervousSystem.wasting.note && (
              <div style={flexRow}>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.wasting.note}</Value>
                </span>

                {/* Delete button for note (only one delete button when note exists) */}
                <ChiefComplainDeleteBtn
                  action={() => deleteData('wasting.note')}
                  itemName="wasting note"
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
          </li>
        )}

        {/* Render Power */}
        {(nervousSystem?.power?.value || nervousSystem?.power?.note) && (
          <li>
            <div style={flexRow}>
              <span className="text-left">
                <Title>Power: </Title>
                <Value>
                  {nervousSystem.power.value}
                  {/* Render type only if value exists */}
                  {nervousSystem.power.value &&
                  nervousSystem.power.type?.length > 0
                    ? ` - ${nervousSystem.power.type.join(', ')}`
                    : ''}
                </Value>
              </span>

              {/* Delete button for value and type */}
              {nervousSystem.power.value && (
                <ChiefComplainDeleteBtn
                  action={() => deleteData('power')}
                  itemName="power"
                  isDelBtn={isDelBtn}
                />
              )}
            </div>

            {/* Render Note on a new line */}
            {nervousSystem.power.note && (
              <div style={flexRow}>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.power.note}</Value>
                </span>

                {/* Delete button for note */}
                <ChiefComplainDeleteBtn
                  action={() => deleteData('power.note')}
                  itemName="power note"
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
          </li>
        )}

        {/* Render Jerks */}
        {Object.entries(nervousSystem?.jerks || {})
          .filter(([, item]) => item?.checked)
          .map(([key, item]) => {
            const jerkLabels = {
              biceps: 'Biceps',
              triceps: 'Triceps',
              supinator: 'Supinator',
              knee: 'Knee',
              ankle: 'Ankle',
              jaw: 'Jaw',
            };
            return (
              <li key={key} style={flexRow}>
                <span className="text-left">
                  <Title>Jerks ({jerkLabels[key] || key}): </Title>
                  <Value>
                    {item.status}
                    {item.note ? ` - ${item.note}` : ''}
                  </Value>
                </span>
                <ChiefComplainDeleteBtn
                  action={() => deleteData(`jerks.${key}`)}
                  itemName={`jerks ${key}`}
                  isDelBtn={isDelBtn}
                />
              </li>
            );
          })}

        {/* Render Reflexes */}
        {Object.entries(nervousSystem?.plantorResponse || {})
          .filter(([, item]) => item?.checked)
          .map(([key, item]) => {
            const reflexLabels = {
              glabellar: "Glabellar (Myerson's sign)",
              planterRt: 'Planter RT',
              planterLt: 'Planter LT',
            };
            return (
              <li key={key} style={flexRow}>
                <span className="text-left">
                  <Title>Reflexes ({reflexLabels[key] || key}): </Title>
                  <Value>
                    {item.status}
                    {item.note ? ` - ${item.note}` : ''}
                  </Value>
                </span>
                <ChiefComplainDeleteBtn
                  action={() => deleteData(`plantorResponse.${key}`)}
                  itemName={`plantor response ${key}`}
                  isDelBtn={isDelBtn}
                />
              </li>
            );
          })}
      </ul>

      {/* Render Gait */}
      {(nervousSystem?.gaitFunction?.status ||
        nervousSystem?.gaitFunction?.note) && (
        <>
          <div className="pl-0 fw-bold">
            <b>Gait</b>
          </div>
          <ul>
            <li>
              <div style={flexRow}>
                <span className="text-left">
                  <Title>Gait: </Title>
                  <Value>
                    {nervousSystem.gaitFunction.status}
                    {/* Render type only if status exists */}
                    {nervousSystem.gaitFunction.status &&
                    nervousSystem.gaitFunction.type
                      ? ` - ${nervousSystem.gaitFunction.type}`
                      : ''}
                  </Value>
                </span>

                {/* Delete button for status and type */}
                {nervousSystem.gaitFunction.status && (
                  <ChiefComplainDeleteBtn
                    action={() => deleteData('gaitFunction')}
                    itemName="gait function"
                    isDelBtn={isDelBtn}
                  />
                )}
              </div>

              {/* Render Note on a new line */}
              {nervousSystem.gaitFunction.note && (
                <div style={flexRow}>
                  <span className="text-left pl-2">
                    <Value>- {nervousSystem.gaitFunction.note}</Value>
                  </span>

                  {/* Delete button for note */}
                  <ChiefComplainDeleteBtn
                    action={() => deleteData('gaitFunction.note')}
                    itemName="gait function note"
                    isDelBtn={isDelBtn}
                  />
                </div>
              )}
            </li>
          </ul>
        </>
      )}

      {(nervousSystem?.slrTest?.rt || nervousSystem?.slrTest?.note) && (
        <>
          <div className="pl-0 fw-bold">
            <b>SLR Test</b>
          </div>
          <ul>
            {nervousSystem?.slrTest?.rt && (
              <li style={flexRow}>
                <span className="text-left">
                  <Title>SLR TEST RT: </Title>
                  <Value>{nervousSystem.slrTest.rt}</Value>
                </span>
                <ChiefComplainDeleteBtn
                  action={() => deleteData('slrTest.rt')}
                  itemName=""
                  isDelBtn={isDelBtn}
                />
              </li>
            )}
            {nervousSystem?.slrTest?.lt && (
              <li style={flexRow}>
                <span className="text-left">
                  <Title>SLR TEST LT: </Title>
                  <Value>{nervousSystem.slrTest.lt}</Value>
                </span>
                <ChiefComplainDeleteBtn
                  action={() => deleteData('slrTest.lt')}
                  itemName=""
                  isDelBtn={isDelBtn}
                />
              </li>
            )}
          </ul>
        </>
      )}

      {/* Render Cerebellar Function */}

      {(nervousSystem?.cerebellarFunction?.status ||
        nervousSystem?.cerebellarFunction?.note) && (
        <>
          <div className="pl-0   fw-bold">
            <b>Cerebellar Function</b>
          </div>
          <ul>
            <li>
              <div style={flexRow}>
                <span className="text-left">
                  <Title>Cerebellar Function: </Title>
                  <Value>
                    {nervousSystem.cerebellarFunction.status}
                    {/* Only render the type if status exists */}
                    {nervousSystem.cerebellarFunction.status &&
                    nervousSystem.cerebellarFunction.type
                      ? ` - ${nervousSystem.cerebellarFunction.type}`
                      : ''}
                  </Value>
                </span>

                {/* Delete button for status and type */}
                {nervousSystem.cerebellarFunction.status && (
                  <ChiefComplainDeleteBtn
                    action={() => deleteData('cerebellarFunction')}
                    itemName="cerebellar function"
                    isDelBtn={isDelBtn}
                  />
                )}
              </div>

              {/* Render Note on a new line */}
              {nervousSystem.cerebellarFunction.note && (
                <div style={flexRow}>
                  <span className="text-left pl-2">
                    <Value>- {nervousSystem.cerebellarFunction.note}</Value>
                  </span>

                  {/* Delete button for note */}
                  <ChiefComplainDeleteBtn
                    action={() => deleteData('cerebellarFunction.note')}
                    itemName="cerebellar function note"
                    isDelBtn={isDelBtn}
                  />
                </div>
              )}
            </li>
          </ul>
        </>
      )}

      {/* Render Sensory System */}
      {(nervousSystem?.sensorySystem?.status ||
        nervousSystem?.sensorySystem?.note) && (
        <>
          <div className="pl-0   fw-bold">
            <b>Sensory System</b>
          </div>
          <ul>
            <li>
              <div style={flexRow}>
                <span className="text-left">
                  <Title>Sensory System: </Title>
                  <Value>
                    {nervousSystem.sensorySystem.status}
                    {/* Render type only if status exists */}
                    {nervousSystem.sensorySystem.status &&
                    nervousSystem.sensorySystem.type
                      ? ` - ${nervousSystem.sensorySystem.type}`
                      : ''}
                  </Value>
                </span>

                {/* Delete button for status and type */}
                {nervousSystem.sensorySystem.status && (
                  <ChiefComplainDeleteBtn
                    action={() => deleteData('sensorySystem')}
                    itemName="sensory system"
                    isDelBtn={isDelBtn}
                  />
                )}
              </div>

              {/* Render Note on a new line */}
              {nervousSystem.sensorySystem.note && (
                <div style={flexRow}>
                  <span className="text-left pl-2">
                    <Value>- {nervousSystem.sensorySystem.note}</Value>
                  </span>

                  {/* Delete button for note */}
                  <ChiefComplainDeleteBtn
                    action={() => deleteData('sensorySystem.note')}
                    itemName="sensory system note"
                    isDelBtn={isDelBtn}
                  />
                </div>
              )}
            </li>
          </ul>
        </>
      )}

      {(nervousSystem?.neckRigidity?.status ||
        nervousSystem?.neckRigidity?.note ||
        nervousSystem?.kernigSign?.status ||
        nervousSystem?.kernigSign?.note ||
        nervousSystem?.brudzinskiSign?.status ||
        nervousSystem?.brudzinskiSign?.note) && (
        <div className="fw-bold">
          <b>Signs of Meniaged Imitation</b>
        </div>
      )}
      <ul>
        {/* Render Neck Rigidity */}
        {nervousSystem?.neckRigidity?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Neck Rigidity: </Title>
              <Value>{nervousSystem.neckRigidity.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('neckRigidity.status')}
              itemName="neckRigidity.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Neck Rigidity with Note */}
        {nervousSystem?.neckRigidity?.status &&
        nervousSystem?.neckRigidity?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.neckRigidity.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('neckRigidity.note')}
              itemName="neckRigidity.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.neckRigidity?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Neck Rigidity: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.neckRigidity.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('neckRigidity.note')}
                itemName="neckRigidity.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Kernig Sign */}
        {nervousSystem?.kernigSign?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Kernig Sign: </Title>
              <Value>{nervousSystem.kernigSign.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('kernigSign.status')}
              itemName="kernigSign.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Kernig Sign with Note */}
        {nervousSystem?.kernigSign?.status &&
        nervousSystem?.kernigSign?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.kernigSign.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('kernigSign.note')}
              itemName="kernigSign.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.kernigSign?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Kernig Sign: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.kernigSign.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('kernigSign.note')}
                itemName="kernigSign.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Brudzinski Sign */}
        {nervousSystem?.brudzinskiSign?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Brudzinski Sign: </Title>
              <Value>{nervousSystem.brudzinskiSign.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('brudzinskiSign.status')}
              itemName="brudzinskiSign.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Brudzinski Sign with Note */}
        {nervousSystem?.brudzinskiSign?.status &&
        nervousSystem?.brudzinskiSign?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.brudzinskiSign.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('brudzinskiSign.note')}
              itemName="brudzinskiSign.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.brudzinskiSign?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Brudzinski Sign: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.brudzinskiSign.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('brudzinskiSign.note')}
                itemName="brudzinskiSign.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}
      </ul>
      {(nervousSystem?.jvp?.status ||
        nervousSystem?.jvp?.note ||
        nervousSystem?.pulse.status ||
        nervousSystem?.pulse.note ||
        nervousSystem?.murmur.status ||
        nervousSystem?.murmur.note) && (
        <div className="pl-2 fw-bold">
          <b>Cardiovascular System</b>
        </div>
      )}
      <ul>
        {/* Render JVP */}
        {nervousSystem?.jvp?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>JVP: </Title>
              <Value>{nervousSystem.jvp.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('jvp.status')}
              itemName="jvp.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render JVP with Note */}
        {nervousSystem?.jvp?.status && nervousSystem?.jvp?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.jvp.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('jvp.note')}
              itemName="jvp.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.jvp?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>JVP: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.jvp.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('jvp.note')}
                itemName="jvp.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Pulse */}
        {nervousSystem?.pulse?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Pulse: </Title>
              <Value>{nervousSystem.pulse.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('pulse.status')}
              itemName="pulse.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Pulse with Note */}
        {nervousSystem?.pulse?.status && nervousSystem?.pulse?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.pulse.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('pulse.note')}
              itemName="pulse.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.pulse?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Pulse: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.pulse.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('pulse.note')}
                itemName="pulse.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Murmur */}
        {nervousSystem?.murmur?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Murmur: </Title>
              <Value>{nervousSystem.murmur.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('murmur.status')}
              itemName="murmur.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Murmur with Note */}
        {nervousSystem?.murmur?.status && nervousSystem?.murmur?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.murmur.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('murmur.note')}
              itemName="murmur.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.murmur?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Murmur: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.murmur.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('murmur.note')}
                itemName="murmur.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}
      </ul>
      {(nervousSystem?.ascitis?.status ||
        nervousSystem?.ascitis?.note ||
        nervousSystem?.hepatomegaly.status ||
        nervousSystem?.hepatomegaly.note ||
        nervousSystem?.splenomegaly.status ||
        nervousSystem?.splenomegaly.note) && (
        <div className="pl-2 fw-bold">
          <b>Gastrointestinal System</b>
        </div>
      )}
      <ul>
        {/* Render Ascitis */}
        {nervousSystem?.ascitis?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Ascitis: </Title>
              <Value>{nervousSystem.ascitis.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('ascitis.status')}
              itemName="ascitis.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Ascitis with Note */}
        {nervousSystem?.ascitis?.status && nervousSystem?.ascitis?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.ascitis.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('ascitis.note')}
              itemName="ascitis.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.ascitis?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Ascitis: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.ascitis.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('ascitis.note')}
                itemName="ascitis.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Hepatomegaly */}
        {nervousSystem?.hepatomegaly?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Hepatomegaly: </Title>
              <Value>{nervousSystem.hepatomegaly.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('hepatomegaly.status')}
              itemName="hepatomegaly.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Hepatomegaly with Note */}
        {nervousSystem?.hepatomegaly?.status &&
        nervousSystem?.hepatomegaly?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.hepatomegaly.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('hepatomegaly.note')}
              itemName="hepatomegaly.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.hepatomegaly?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Hepatomegaly: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.hepatomegaly.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('hepatomegaly.note')}
                itemName="hepatomegaly.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Splenomegaly */}
        {nervousSystem?.splenomegaly?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Splenomegaly: </Title>
              <Value>{nervousSystem.splenomegaly.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('splenomegaly.status')}
              itemName="splenomegaly.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Splenomegaly with Note */}
        {nervousSystem?.splenomegaly?.status &&
        nervousSystem?.splenomegaly?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.splenomegaly.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('splenomegaly.note')}
              itemName="splenomegaly.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.splenomegaly?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Splenomegaly: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.splenomegaly.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('splenomegaly.note')}
                itemName="splenomegaly.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}
      </ul>
      {(nervousSystem?.rr?.status ||
        nervousSystem?.rr?.note ||
        nervousSystem?.rr?.status ||
        nervousSystem?.rr?.note ||
        nervousSystem?.rhanchi?.status ||
        nervousSystem?.rhanchi?.note ||
        nervousSystem?.creps?.status ||
        nervousSystem?.creps?.note ||
        nervousSystem?.breathSound?.status ||
        nervousSystem?.breathSound?.note) && (
        <div className="pl-2 fw-bold">
          <b>Respiratory System</b>
        </div>
      )}
      <ul>
        {/* Render RR */}
        {nervousSystem?.rr?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>RR: </Title>
              <Value>{nervousSystem.rr.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('rr.status')}
              itemName="rr.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render RR with Note */}
        {nervousSystem?.rr?.status && nervousSystem?.rr?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.rr.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('rr.note')}
              itemName="rr.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.rr?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>RR: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.rr.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('rr.note')}
                itemName="rr.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Rhanchi */}
        {nervousSystem?.rhanchi?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Rhanchi: </Title>
              <Value>{nervousSystem.rhanchi.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('rhanchi.status')}
              itemName="rhanchi.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Rhanchi with Note */}
        {nervousSystem?.rhanchi?.status && nervousSystem?.rhanchi?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.rhanchi.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('rhanchi.note')}
              itemName="rhanchi.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.rhanchi?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Rhanchi: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.rhanchi.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('rhanchi.note')}
                itemName="rhanchi.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Creps */}
        {nervousSystem?.creps?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Creps: </Title>
              <Value>{nervousSystem.creps.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('creps.status')}
              itemName="creps.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Creps with Note */}
        {nervousSystem?.creps?.status && nervousSystem?.creps?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.creps.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('creps.note')}
              itemName="creps.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.creps?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Creps: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.creps.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('creps.note')}
                itemName="creps.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}

        {/* Render Breath Sound */}
        {nervousSystem?.breathSound?.status && (
          <li style={flexRow}>
            <span className="text-left">
              <Title>Breath Sound: </Title>
              <Value>{nervousSystem.breathSound.status}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('breathSound.status')}
              itemName="breathSound.status"
              isDelBtn={isDelBtn}
            />
          </li>
        )}

        {/* Render Breath Sound with Note */}
        {nervousSystem?.breathSound?.status &&
        nervousSystem?.breathSound?.note ? (
          <div style={flexRow}>
            <span className="text-left pl-2">
              <Value>- {nervousSystem.breathSound.note}</Value>
            </span>
            <ChiefComplainDeleteBtn
              action={() => deleteData('breathSound.note')}
              itemName="breathSound.note"
              isDelBtn={isDelBtn}
            />
          </div>
        ) : (
          nervousSystem?.breathSound?.note && (
            <li style={flexRow}>
              <span className="text-left">
                <div>
                  <Title>Breath Sound: </Title>
                </div>
                <span className="text-left pl-2">
                  <Value>- {nervousSystem.breathSound.note}</Value>
                </span>
              </span>
              <ChiefComplainDeleteBtn
                action={() => deleteData('breathSound.note')}
                itemName="breathSound.note"
                isDelBtn={isDelBtn}
              />
            </li>
          )
        )}
      </ul>
    </div>
  );
};

export default NervousSystem;
